import React, { Component, Fragment } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import { Collapse } from 'wanderu-animations';
import A from 'wanderu-component-react-router-link';
import { Button } from 'wanderu-components';
import { localize } from 'wanderu-i18n';
import {
    ChevronUp,
    ChevronDown,
} from 'wanderu-icons';

import CollapsibleLinkRowEvents from './events/CollapsibleLinkRowEvents';

import styles from './CollapsibleLinkRow.scss';

function RowItem({ url, title, price }) {
    return (
        <li className={styles.item}>
            <A
                href={url}
                variant="subdued"
            >
                <span className={styles.itemLeft}>
                    {title}
                </span>
            </A>
            {!!price && (
                <span className={styles.itemRight}>
                    {price}
                </span>
            )}
        </li>
    );
}

class CollapsibleLinkRow extends Component {
    static propTypes = {
        data: PropTypes.object.isRequired,
        header: PropTypes.string.isRequired,
    };

    static defaultProps = {
        data: {},
        header: '',
    };

    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
        };
    }

    _toggleOpen = () => {
        CollapsibleLinkRowEvents.linkDropdownClicked();

        this.setState((oldState) => ({ isOpen: !oldState.isOpen }));
    }

    render() {
        const {
            data,
            header,
            t,
            i18nMoney,
        } = this.props;
        const { isOpen } = this.state;

        const Icon = isOpen
            ? ChevronUp
            : ChevronDown;

        return (
            <div className={styles.row}>
                <h3
                    className={classNames(
                        styles.header,
                        { [styles.active]: isOpen },
                    )}
                    id={header}
                >
                    <Button
                        aria-controls={`${header}-collapse`}
                        aria-expanded={isOpen}
                        data-id="toggleRow"
                        onClick={this._toggleOpen}
                        type="button"
                        unstyled
                    >
                        {t(header)}
                        <Icon className={styles.caretIcon} />
                    </Button>
                </h3>
                <Collapse
                    aria-labelledby={header}
                    duration={500}
                    id={`${header}-collapse`}
                    isOpen={isOpen}
                >
                    {Object.keys(data).map((transMode) => (
                        <Fragment key={transMode}>
                            <A
                                className={styles.transModeTitle}
                                href={data[transMode][0].placeGuideUrl}>
                                {t.plural(`baseApp:${transMode}`, 2)}
                            </A>
                            <ul className={styles.list}>
                                {data[transMode].map((row) => (
                                    <RowItem
                                        key={row.url}
                                        price={row.price
                                            ? `${i18nMoney(row.price).format({
                                                maximumFractionDigits: 0,
                                                minimumFractionDigits: 0,
                                            })}+`
                                            : null}
                                        title={row.title}
                                        url={row.url}
                                    />
                                ))}
                            </ul>
                        </Fragment>
                    ))}
                </Collapse>
            </div>
        );
    }
}

export {
    CollapsibleLinkRow,
    RowItem,
};

const LocalizedCollapsibleLinkRow = localize(CollapsibleLinkRow, ['t', 'i18nMoney']);
export default LocalizedCollapsibleLinkRow;
